angular.module('impactx.cube').service('PrintCubeService', PrintCubeService);

PrintCubeService.$inject = ['$config', '$securityManager', 'CubeConfigService'];

/**
 * Service for configuring a cube
 * @param dataGen Data service
 * @constructor
 */
function PrintCubeService( $config, $securityManager, CubeConfigService) {

    /**
     * Print the cube; i.e. call
     */
    this.print = function () {
        var form = document.createElement('form');
        form.action = $config.sourceURL + "/monitor/cube/print";
        form.method = 'POST';
        form.target = '_blank';
        form.style.display = 'none';

        var input = document.createElement('input');
        input.type = 'text';
        input.name = 'token';
        input.value = $securityManager.getToken();

        var input2 = document.createElement('input');
        input2.name = 'cube';
        input2.value = angular.toJson(CubeConfigService.selectedCube);

        var submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = 'submitForm';

        form.appendChild(input);
        form.appendChild(input2);
        form.appendChild(submit);
        document.body.appendChild(form);

        $('#submitForm').click();

        document.body.removeChild(form);
    }


}
